import { render, staticRenderFns } from "./RequirementCommentItem.vue?vue&type=template&id=65fe05f7"
import script from "./RequirementCommentItem.vue?vue&type=script&lang=js"
export * from "./RequirementCommentItem.vue?vue&type=script&lang=js"
import style0 from "./RequirementCommentItem.vue?vue&type=style&index=0&id=65fe05f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports